export const MARK_FIRST_VIRTUAL_FARM_TOUR_COMPLETE = 'MARK_FIRST_VIRTUAL_FARM_TOUR_COMPLETE';